// Whether a point in a view's pixels is out of view. No imports at all, so its test
// (Vitest, node environment, no DOM) can load this file.

/** How close to an edge, in pixels, a point still counts as out of view. */
export const REVEAL_MARGIN_PX = 32;

/**
 * When a twin selected in another view is "out of view" in a flat view (a map,
 * a graph): its point, in the view's pixels, lies outside the view or within
 * `margin` of an edge. Only then does the view pan (centring the twin, zoom
 * unchanged); a twin already on screen leaves the camera alone. A point that
 * is not a number counts as out of view.
 */
export function outsideView(
  x: number,
  y: number,
  width: number,
  height: number,
  margin = REVEAL_MARGIN_PX,
): boolean {
  return !(x >= margin && y >= margin && x <= width - margin && y <= height - margin);
}
